import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VLayout,{attrs:{"justify-center":"","wrap":""}},[_c(VFlex,{attrs:{"md12":""}},[_c('app-table',{ref:"table",attrs:{"api-getlist":_vm.getList,"config":_vm.configIndex}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }